import '~/pages/projects/pipelines/index/index';
import initVueAlerts from '~/vue_alerts';

initVueAlerts();
